<template>
  <v-dialog persistent="" :model-value="dialog" width="auto">
    <v-card
      flat
      width="600"
      :style="{
        borderBottom: '3px solid #272727',
        borderLeft: '1px solid #272727',
        borderTop: '1px solid #272727',
        borderRight: '3px solid #272727',
      }"
    >
      <v-sheet
        class="d-flex justify-center align-center py-2"
        color="accent"
        style="font-size: 10pt; font-weight: 600"
      >
        Import structure
      </v-sheet>
      <v-divider class="primary"></v-divider>
      <div class="pa-6">
        <div>
          <p style="font-size: 10pt" class="mb-2">Name:</p>
          <v-text-field
            variant="solo"
            flat
            bg-color="smoke"
            v-model="localStructure.title"
          ></v-text-field>
        </div>
        <div>
          <p style="font-size: 10pt" class="mb-2">Structure description:</p>
          <v-textarea
            rows="10"
            variant="solo"
            flat
            bg-color="smoke"
            v-model="localStructure.text"
          ></v-textarea>
        </div>
      </div>
      <v-divider></v-divider>

      <template v-slot:actions>
        <v-btn text="Close" @click="$emit('close')"></v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text="Add"
          variant="flat"
          @click="$emit('add')"
          color="success"
        ></v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      workspace: (state) => state.workspace.workspace,
      accounts: (state) => state.accounts.accounts,
      loading: (state) => state.loading,
      categories: (state) => state.posts.categories,
    }),

    localStructure: {
      get() {
        return this.structure;
      },
      set(newValue) {
        this.$emit("update:structure", newValue); // Emit event to update parent
      },
    },
  },
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    structure: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
};
</script>
